import React from 'react';
import PropTypes from 'prop-types';
import { PSPMarkdownModule } from 'components/psp/PSPMarkdown';
import PSPImage from 'components/psp/PSPImage/PSPImage';
import { PSPFAQ } from 'components/psp/PSPFAQ';
import { PSPTable } from 'components/psp/PSPTable';
import { PSPUnitCards } from 'components/psp/PSPUnitCards';
import { PSPList } from 'components/psp/PSPList';
import { PSPCities } from 'components/psp/PSPCities';
import { PSPSectionHeader } from 'components/psp/PSPSectionHeader';
import { PSPVehicleSearch } from 'components/psp/PSPVehicleSearch';
import {
	PSPSizeChartSection,
	FeaturedContent,
	PSPLinks,
	PSPStorageNearYou,
	PSPHero,
	PSPReviewSection,
	UnitList,
	PSPVideo,
	PSPContentSection,
	FAQSection,
	CTABlock,
	PLPFacilitiesSection,
	AlternateContentSection,
	CardBlockSection,
	IconContentBlock,
	SecondaryNav,
} from '../../organisms';
import { PortableStorageComparison } from 'components/brand/PortableStorageComparison/PortableStorageComparison';
import { PortableStoragePromoCards } from 'components/brand/PortableStoragePromoCards/PortableStoragePromoCards';
import StorageCalculatorEmbed from 'components/calculator/StorageCalculatorEmbed';
import {SectionHeader} from 'components/molecules/SectionHeader';
import StorageCalculatorEmbedSGP from 'components/molecules/CalculatorSGP/StorageCalculatorEmbedSGP';

export const PSPPageSectionsMap = {
	markdownSection: PSPMarkdownModule,
	storageCalculatorEmbed: StorageCalculatorEmbed,
	videoSection: PSPVideo,
	imageSection: PSPImage,
	tableSection: PSPTable,
	faqSection: PSPFAQ,
	unitCards: PSPUnitCards,
	listSection: PSPList,
	citiesSection: PSPCities,
	newVideoSection: PSPVideo,
	sectionHeader: PSPSectionHeader,
	commonSectionHeader: SectionHeader,
	vehicleSearch: PSPVehicleSearch,
	hero: PSPHero,
	reviews: PSPReviewSection,
	storageNearYou: PSPStorageNearYou,
	unitList: UnitList,
	links: PSPLinks,
	featuredContent: FeaturedContent,
	sizeChart: PSPSizeChartSection,
	content: PSPContentSection,
	alternatingContent: AlternateContentSection,
	cardBlockContent: CardBlockSection,
	faqs: FAQSection,
	facilitiesNearYou: PLPFacilitiesSection,
	inlineCTA: CTABlock,
	PortableStorageComparison: PortableStorageComparison,
	PortableStoragePromoCards: PortableStoragePromoCards,
	IconContentBlock: IconContentBlock,
	SecondaryNav: SecondaryNav,
	storageCalculatorEmbedSGP: StorageCalculatorEmbedSGP,
};

function PSPModuleFactory({ type, props, children }) {
	if (type in PSPPageSectionsMap) {
		return React.createElement(
			PSPPageSectionsMap[type],
			{ ...props },
			children
		);
	}
	return null;
}

PSPModuleFactory.propTypes = {
	children: PropTypes.node,
	props: PropTypes.object,
	type: PropTypes.string,
};

export default PSPModuleFactory;
